// material
import { experimentalStyled as styled } from '@mui/material/styles';
import { Card, Box, Stack, Container, Typography } from '@mui/material';
// components
import Page from '../components/Page';
import { LoginForm } from '../components/authentication/login';
import BackgroundImage from '../svg/FainlearnBackSvg.svg';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  width: '100%',
  margin: 'auto',
  display: 'flex',
  // minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle
      title="Fainlearn | Login - Signup"
      isDivRender={false}
      style={{
        // background:
        //   'linear-gradient(140.82deg, rgba(251, 133, 0, 0.06) 0%, rgba(25, 117, 255, 0.06) 102.19%)',
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: 'cover',
        alignItems: 'center'
      }}
    >
      <Container
        maxWidth="sm"
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Card style={{ position: 'relative' }}>
          <Box
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: 20
            }}
          >
            <Box component="img" src="/static/logo-new.svg" sx={{ height: '100px' }} />
            <ContentStyle style={{ margin: '0 15px', paddingTop: 0, paddingBottom: '50px' }}>
              <Stack sx={{ mb: 5 }}>
                <Typography variant="h4" gutterBottom textAlign="center">
                  Welcome to fainlearn!
                </Typography>
                <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                  Lets get you started with amazing learning experience.
                </Typography>
              </Stack>
              <LoginForm />
            </ContentStyle>
          </Box>
        </Card>
      </Container>
    </RootStyle>
  );
}
